var map = {
	"./": "./test/index.ts",
	"./TestAlert": "./test/TestAlert.ts",
	"./TestAlert.ts": "./test/TestAlert.ts",
	"./TestAlign": "./test/TestAlign.ts",
	"./TestAlign.ts": "./test/TestAlign.ts",
	"./TestAnimationJitter": "./test/TestAnimationJitter.ts",
	"./TestAnimationJitter.ts": "./test/TestAnimationJitter.ts",
	"./TestApplication": "./test/TestApplication.ts",
	"./TestApplication.ts": "./test/TestApplication.ts",
	"./TestArrow": "./test/TestArrow.ts",
	"./TestArrow.ts": "./test/TestArrow.ts",
	"./TestAudio": "./test/TestAudio.ts",
	"./TestAudio.ts": "./test/TestAudio.ts",
	"./TestAutoContainer": "./test/TestAutoContainer.ts",
	"./TestAutoContainer.ts": "./test/TestAutoContainer.ts",
	"./TestButton": "./test/TestButton.ts",
	"./TestButton.ts": "./test/TestButton.ts",
	"./TestCamera": "./test/TestCamera.ts",
	"./TestCamera.ts": "./test/TestCamera.ts",
	"./TestCheckBox": "./test/TestCheckBox.ts",
	"./TestCheckBox.ts": "./test/TestCheckBox.ts",
	"./TestCircle": "./test/TestCircle.ts",
	"./TestCircle.ts": "./test/TestCircle.ts",
	"./TestConnectLine": "./test/TestConnectLine.ts",
	"./TestConnectLine.ts": "./test/TestConnectLine.ts",
	"./TestContainer": "./test/TestContainer.ts",
	"./TestContainer.ts": "./test/TestContainer.ts",
	"./TestDrag": "./test/TestDrag.ts",
	"./TestDrag.ts": "./test/TestDrag.ts",
	"./TestEllipse": "./test/TestEllipse.ts",
	"./TestEllipse.ts": "./test/TestEllipse.ts",
	"./TestFillColor": "./test/TestFillColor.ts",
	"./TestFillColor.ts": "./test/TestFillColor.ts",
	"./TestFollowLine": "./test/TestFollowLine.ts",
	"./TestFollowLine.ts": "./test/TestFollowLine.ts",
	"./TestGridLayout": "./test/TestGridLayout.ts",
	"./TestGridLayout.ts": "./test/TestGridLayout.ts",
	"./TestImage": "./test/TestImage.ts",
	"./TestImage.ts": "./test/TestImage.ts",
	"./TestIsosceles": "./test/TestIsosceles.ts",
	"./TestIsosceles.ts": "./test/TestIsosceles.ts",
	"./TestLabel": "./test/TestLabel.ts",
	"./TestLabel.ts": "./test/TestLabel.ts",
	"./TestMatter": "./test/TestMatter.ts",
	"./TestMatter.ts": "./test/TestMatter.ts",
	"./TestMouseCursor": "./test/TestMouseCursor.ts",
	"./TestMouseCursor.ts": "./test/TestMouseCursor.ts",
	"./TestMove": "./test/TestMove.ts",
	"./TestMove.ts": "./test/TestMove.ts",
	"./TestPathTimeLine": "./test/TestPathTimeLine.ts",
	"./TestPathTimeLine.ts": "./test/TestPathTimeLine.ts",
	"./TestPolygon": "./test/TestPolygon.ts",
	"./TestPolygon.ts": "./test/TestPolygon.ts",
	"./TestRect": "./test/TestRect.ts",
	"./TestRect.ts": "./test/TestRect.ts",
	"./TestScrollBar": "./test/TestScrollBar.ts",
	"./TestScrollBar.ts": "./test/TestScrollBar.ts",
	"./TestScrollingContainer": "./test/TestScrollingContainer.ts",
	"./TestScrollingContainer.ts": "./test/TestScrollingContainer.ts",
	"./TestSlider": "./test/TestSlider.ts",
	"./TestSlider.ts": "./test/TestSlider.ts",
	"./TestSortableList": "./test/TestSortableList.ts",
	"./TestSortableList.ts": "./test/TestSortableList.ts",
	"./TestSpriteAnimated": "./test/TestSpriteAnimated.ts",
	"./TestSpriteAnimated.ts": "./test/TestSpriteAnimated.ts",
	"./TestStar": "./test/TestStar.ts",
	"./TestStar.ts": "./test/TestStar.ts",
	"./TestStyle": "./test/TestStyle.ts",
	"./TestStyle.ts": "./test/TestStyle.ts",
	"./TestSyncInteraction": "./test/TestSyncInteraction.ts",
	"./TestSyncInteraction.ts": "./test/TestSyncInteraction.ts",
	"./TestTextInput": "./test/TestTextInput.ts",
	"./TestTextInput.ts": "./test/TestTextInput.ts",
	"./TestTicker": "./test/TestTicker.ts",
	"./TestTicker.ts": "./test/TestTicker.ts",
	"./TestTimeLine": "./test/TestTimeLine.ts",
	"./TestTimeLine.ts": "./test/TestTimeLine.ts",
	"./TestToDivPoint": "./test/TestToDivPoint.ts",
	"./TestToDivPoint.ts": "./test/TestToDivPoint.ts",
	"./TestTracing": "./test/TestTracing.ts",
	"./TestTracing.ts": "./test/TestTracing.ts",
	"./TestTween": "./test/TestTween.ts",
	"./TestTween.ts": "./test/TestTween.ts",
	"./TestTween2": "./test/TestTween2.ts",
	"./TestTween2.ts": "./test/TestTween2.ts",
	"./TestVideo": "./test/TestVideo.ts",
	"./TestVideo.ts": "./test/TestVideo.ts",
	"./index": "./test/index.ts",
	"./index.ts": "./test/index.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./test sync recursive ^\\.\\/.*$";